export default __webpack_public_path__ + "static/lilnadas-cards-story-3-6702a15cc34f093e12a9b068fc064626.png";